// extracted by mini-css-extract-plugin
export var growableInput = "_5x-0";
export var tagContainer = "_5x-2";
export var textInput = "_5x-1";